//  import { List as ImmutableList } from 'immutable';

//  import { DateTime } from 'luxon';
import { TRANSFER_HISTORY_REDUCER_KEY } from './transferHistoryReducer';

export const getResourceStore = (state) => state[TRANSFER_HISTORY_REDUCER_KEY];
export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const getIsLoading = (state) => getResourceStore(state).isLoading;
export const getLastSyncDate = (state) => getResourceStore(state).lastSyncDate;
export const getError = (state) => getResourceStore(state).error;
export const getResourcesById = (state) => getResourceStore(state).resourcesById;
